import { gql } from 'graphql-request'

export const downloadByArquivoGql = gql`
  mutation downloadByArquivoMutation(
    $idArquivo: ID!
    $registrarDownload: Boolean!
  ) {
    downloadByArquivo(
      idArquivo: $idArquivo
      registrarDownload: $registrarDownload
    )
  }
`
